import { enqueueSnackbar } from '~/utils/notifications';
import { SkipReport } from './FileHandler';

const NAMES_TO_SHOW = 3;

function formatNames(names: string[]): string {
    if (names.length <= NAMES_TO_SHOW) {
        return names.join(', ');
    }
    const shown = names.slice(0, NAMES_TO_SHOW).join(', ');
    const extra = names.length - NAMES_TO_SHOW;
    return `${shown}, +${extra} more`;
}

export function emitSkipReportToasts(report: SkipReport): void {
    if (report.skips.length === 0) {
        return;
    }
    const summary =
        `${report.skips.length} of ${report.examined} files skipped: ` +
        `could not be imported as DICOM`;
    // The user-facing toast lists filenames (PHI) so the user can locate
    // the skipped files; `logMessage` drops the names to keep the console
    // mirror in WarningSnackbarContent PHI-free.
    const names = formatNames(report.skips.map((skip) => skip.fileName));
    enqueueSnackbar(`${summary} (${names}).`, {
        variant: 'warning',
        logMessage: `${summary}.`,
    });
}
